import { ElementDefinition } from '@amzn/exs-elements/web-component';

const tagName = 'amazon-cart';

const definition: ElementDefinition = {
  // make sure tagName is same as the folder name
  tagName,
  schema: undefined,
  version: 'v1.0',
  shadowMode: 'closed',
  singleton: true,
};

// export default is required for definition.ts
export default definition;
